import { ColumnConfig, CreditsColumnKey } from '../../model';

export const creditsConfig: Record<CreditsColumnKey, ColumnConfig> = {
  date: { name: 'Date' },
  type: { name: 'Type' },
  count: { name: 'Count', alignment: 'flex-end' },
  debit: { name: 'Debit', alignment: 'flex-end' },
  credit: { name: 'Credit', alignment: 'flex-end' },

  balance: { name: 'Balance', alignment: 'flex-end' },
};
